import registerServerComponent from 'react-on-rails-pro/registerServerComponent/client';

registerServerComponent("RestaurantDetailRSC");